<template>
  <el-form ref="now" class="app">
      <slot></slot>
  </el-form>
</template>

<script>
export default {
  name: "yzSearchBar",
  props: [
    'queryParams',
    'showSearch',
  ],
  methods:{
    resetFields(){
      this.$refs['now'].resetFields()
      // this.resetFields()
    }
  }
}
</script>

<style scoped>
.app {
  display: flex;
  height: 44px;
  /*border: 1px #b1acac solid;*/
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  /*padding-left: 14px;*/
  /*margin-bottom: 14px;*/
  
}
</style>
